import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "priceSorting row" };
const _hoisted_2 = { class: "col-12 pt-4 border-top" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_v_select = _resolveComponent("v-select");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_v_select, {
                label: "Sortierung",
                items: _ctx.items,
                "item-title": "state",
                "item-value": "abbr",
                modelValue: _ctx.select,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.select) = $event)),
                density: "comfortable",
                "base-color": "#ffffff"
            }, null, 8, ["items", "modelValue"])
        ])
    ]));
}
